import React, { Component } from 'react';
import styled from 'styled-components';
import { translate } from 'react-i18next';

import DeviceCard from '../elements/DeviceCard';
import Button from '../elements/Button';
import SendButton from '../elements/SendButton';
import Heading from '../elements/PageHeading';
import Paragraph from '../elements/Paragraph';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  margin: auto;
  color: ${props => props.theme.secondary};
`;

const Notice = styled.div`
  margin: 0.5em auto 1em;
  padding: 0.6em 1em;
  max-width: 420px;
  text-align: center;
  background: ${props => props.theme.positiveTint || '#e6f4ea'};
  border-radius: 4px;
`;

const Buttons = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: 10px auto 0px;
  align-items: center;
`;

/**
 * scale2 discovery mode: the cabinet unlocks the door and shows every weight lane live on its screen (shelf, slot,
 * lane id, weight); a lane that is pressed lights up. Read only. Start / Stop only, the screen does the rest.
 */
class Scale2DiscoveryPage extends Component {
  render() {
    const {
      t,
      target,
      cancel,
      startDiscovery,
      stopDiscovery,
      message,
    } = this.props;

    return (
      <Wrapper>
        <Heading text={t('management.scale2_discovery')} />
        <DeviceCard device={target || {}} />
        <Paragraph>{t('management.scale2_discovery_instruction')}</Paragraph>
        <Paragraph>{t('management.scale2_screen_note')}</Paragraph>
        {message && <Notice>{t(message)}</Notice>}
        <Buttons>
          <Button onClick={cancel}>{t('button.cancel')}</Button>
          &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;
          <SendButton
            chevron={false}
            feedback
            onClick={() => startDiscovery()}
            text={t('button.startDiscovery')}
          />
          &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;
          <SendButton
            chevron={false}
            feedback
            onClick={() => stopDiscovery()}
            text={t('button.stopDiscovery')}
          />
        </Buttons>
      </Wrapper>
    );
  }
}

export default translate()(Scale2DiscoveryPage);
